__turbopack_context__.v({
  "explanationContactButton": "withExportRestriction-module-scss-module__tNQc9a__explanationContactButton",
  "explanationReference": "withExportRestriction-module-scss-module__tNQc9a__explanationReference",
  "popoverContentClass": "withExportRestriction-module-scss-module__tNQc9a__popoverContentClass",
});
